import React from 'react'

export default function Career() {
  return (
    <>
        <div class="inner-page" id="career-bg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="inner_content" data-aos="fade-up" data-aos-duration="2000">
                            <h1>Careers </h1>
                            <div aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="#"><i class="ri-home-4-line"></i> Home</a></li>
                                    <li class="breadcrumb-item active" aria-current="page">Careers</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="careers_sec">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="heading">
                            <h2>Jobs At Adret Software </h2>
                            <p>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum mollitia blanditiis
                                ducimus, commodi repellendus hic cupiditate reprehenderit nihil cum animi, eius
                                molestiae tenetur earum quia minima vitae totam expedita consectetur?
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="careers_sec1 pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="heading">
                            <h2>CURRENT OPENINGS</h2>

                            <div class="col-md-12">
                                <div class="accordion">

                                    <div class="accordion__item">
                                        <h2 class="accordion__title">Project Manager</h2>
                                        <div class="accordion__body">
                                            <h5>Key Responsibilities:</h5>
                                            <p>
                                                1. Act as the primary point of contact for clients, ensuring their project needs and expectations are met.
                                            </p>
                                            <p>
                                                2. Coordinate project activities and tasks, including scheduling, resource allocation, and project timelines.
                                            </p>
                                            <p>
                                                3. Collaborate closely with cross-functional teams, including developers, designers, and marketers, to ensure project goals are achieved.
                                            </p>
                                            <p>
                                                4. Prepare and maintain project documentation, including project plans, status reports, and communication logs.
                                            </p>
                                            <h5>Qualifications:</h5>
                                            <p>
                                                1. 2-5 years of experience in project coordination, preferably in the IT or software development industry.
                                            </p>
                                            <p>
                                                2. Excellent verbal and written English skills.
                                            </p>
                                            <p>
                                                3. Problem-solving and analytical capabilities.
                                            </p>
                                            <p>
                                                4. Ability to work in a fast-paced, dynamic environment.
                                            </p>
                                            <h5>Job Type:</h5>
                                            <p>Full-time, Permanent</p>
                                        </div>
                                    </div>
                                    <div class="accordion__item">
                                        <h2 class="accordion__title ">Marketing Manager</h2>
                                        <div class="accordion__body">
                                            <h5>Key Responsibilities:</h5>
                                            <p>
                                                1. Act as the primary point of contact for clients, ensuring their project needs and expectations are met.
                                            </p>
                                            <p>
                                                2. Coordinate project activities and tasks, including scheduling, resource allocation, and project timelines.
                                            </p>
                                            <p>
                                                3. Collaborate closely with cross-functional teams, including developers, designers, and marketers, to ensure project goals are achieved.
                                            </p>
                                            <p>
                                                4. Prepare and maintain project documentation, including project plans, status reports, and communication logs.
                                            </p>
                                            <h5>Qualifications:</h5>
                                            <p>
                                                1. 2-5 years of experience in project coordination, preferably in the IT or software development industry.
                                            </p>
                                            <p>
                                                2. Excellent verbal and written English skills.
                                            </p>
                                            <p>
                                                3. Problem-solving and analytical capabilities.
                                            </p>
                                            <p>
                                                4. Ability to work in a fast-paced, dynamic environment.
                                            </p>
                                            <h5>Job Type:</h5>
                                            <p>Full-time, Permanent</p>
                                        </div>
                                    </div>
                                   
                                 
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="row row-below">
                    <div class="col-lg-12">
                        <div class="heading">
                            <p>Send your CV to <strong><a href="">hr@adretsoftware.com</a></strong>, mentioning the post
                                applied for in the subject line.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
